export default "__VITE_ASSET__265eaa83__"